import React, { useEffect } from 'react';
import { Typography, Box, IconButton, Drawer, Overlay, Loader, color } from '@kistech/kis-ui';
import { selectors as adminsSelectors, actions as adminsActions } from 'store/admins';
import { format } from 'date-fns';
import { UpdateUserForm } from './UpdateUserForm';
import { UpdateUserDrawerProps } from '../types';
import { useActions } from 'hooks/useActions';
import { useSelector } from 'react-redux';
import { Grid, Typography as MuiTypography, Box as MuiBox } from '@mui/material';
import { useStyles } from '../styled';

export const UpdateUserDrawer = (props: UpdateUserDrawerProps) => {
  const { isOpen, onClose, admin } = props;
  const { successful, pending } = useSelector(adminsSelectors.selectAction);

  const resetAction = useActions(adminsActions.resetAction);
  const classes = useStyles();

  useEffect(() => {
    if (isOpen && successful) onSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, successful]);

  const onSuccess = () => {
    onClose();
    resetAction();
  };

  return (
    <>
      {pending && (
        <Overlay>
          <Loader color={color.BLACK} />
        </Overlay>
      )}
      <Drawer isOpen={isOpen} onClose={onClose} hasBorderRadius>
        <Grid direction="column" className={classes.updateUserDrawerContainer}>
          <Grid container direction="row" className={classes.drawerAdminNameBlock}>
            <MuiTypography className={classes.updateUserAdminName} style={{ fontWeight: 600 }}>
              Edit User
            </MuiTypography>
            <MuiBox className={classes.updateDrawerCloseIcon}>
              <IconButton
                name="exit_circle"
                appearance="transparent"
                size={40}
                onClick={onClose}
                data-testid="update-user-x"
              />
            </MuiBox>
          </Grid>

          <Box padding="2 6" fullWidth bg="light-gray">
            <Typography weight={600} size={16}>
              {admin.name} Created on {admin.createdAt ? format(new Date(admin.createdAt), 'MMMM dd, yyyy') : ''}
            </Typography>
          </Box>

          <UpdateUserForm admin={admin} />
        </Grid>
      </Drawer>
    </>
  );
};
